(function () {
  'use strict';

  var refreshTimer = null;

  function enableCheckoutIfNeeded() {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    var fs = drawer.querySelector('[data-cart-checkout-button]');
    var btn = drawer.querySelector('button.cart__checkout, button[name="checkout"]');
    var empty = drawer.classList.contains('is-empty');
    if (fs) fs.removeAttribute('disabled');
    if (btn) {
      if (empty) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');
    }
  }

  function sizeSlides(root) {
    var track = root.querySelector('[data-watch-upsell-track]');
    if (!track) return;
    var w = Math.round(track.clientWidth);
    if (w > 0) root.style.setProperty('--may-watch-slide-w', w + 'px');
  }

  function currentIndex(track) {
    var w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }

  function goTo(track, index, slides) {
    var max = Math.max(0, slides.length - 1);
    var i = Math.max(0, Math.min(max, index));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }

  function syncNav(root, track, slides) {
    var prev = root.querySelector('[data-watch-upsell-prev]');
    var next = root.querySelector('[data-watch-upsell-next]');
    var i = currentIndex(track);
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= slides.length - 1;
  }

  function initDots(root) {
    var track = root.querySelector('[data-watch-upsell-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-watch-upsell-slide]'));
    var dotsWrap = root.querySelector('[data-watch-upsell-dots]');
    if (!track || !slides.length) return;

    sizeSlides(root);

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'may-watch-upsell__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Watch ' + (i + 1));
        b.addEventListener('click', function () {
          goTo(track, i, slides);
        });
        dotsWrap.appendChild(b);
      });
    }

    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

    if (track._mayWatchScroll) track.removeEventListener('scroll', track._mayWatchScroll);
    track._mayWatchScroll = function () {
      window.clearTimeout(track._t);
      track._t = window.setTimeout(function () {
        var i = currentIndex(track);
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === i);
        });
        syncNav(root, track, slides);
      }, 40);
    };
    track.addEventListener('scroll', track._mayWatchScroll, { passive: true });

    // Prev / next
    var prev = root.querySelector('[data-watch-upsell-prev]');
    var next = root.querySelector('[data-watch-upsell-next]');
    if (prev && !prev.dataset.bound) {
      prev.dataset.bound = '1';
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(track, currentIndex(track) - 1, slides);
      });
    }
    if (next && !next.dataset.bound) {
      next.dataset.bound = '1';
      next.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(track, currentIndex(track) + 1, slides);
      });
    }

    // Allow horizontal wheel / trackpad
    if (!track._mayWatchWheel) {
      track._mayWatchWheel = function (e) {
        if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;
        e.preventDefault();
        track.scrollLeft += e.deltaX;
      };
      track.addEventListener('wheel', track._mayWatchWheel, { passive: false });
    }

    syncNav(root, track, slides);

    if (!root._mayWatchResize) {
      root._mayWatchResize = function () {
        sizeSlides(root);
      };
      window.addEventListener('resize', root._mayWatchResize);
    }
  }

  function bindAdd(root) {
    root.querySelectorAll('[data-watch-upsell-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        var form = btn.closest('form');
        var idInput = form && form.querySelector('input[name="id"]');
        if (!idInput) return;
        var label = btn.querySelector('[data-watch-upsell-add-label]');
        var slide = btn.closest('[data-watch-upsell-slide]');

        btn.disabled = true;
        btn.classList.add('is-loading');
        if (label) label.textContent = '…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(idInput.value), quantity: 1 }),
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok || (data && data.status)) {
                throw new Error((data && (data.description || data.message)) || 'Add failed');
              }
              return data;
            });
          })
          .then(function () {
            if (slide) slide.remove();
            var root = btn.closest('[data-watch-upsell]');
            if (root) {
              initDots(root);
              if (!root.querySelectorAll('[data-watch-upsell-slide]').length) root.hidden = true;
            }
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            // Do NOT full-replace upsell HTML after ADD — that reloads every thumb (flicker).
            enableCheckoutIfNeeded();
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            if (label) label.textContent = 'ADDED';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.disabled = false;
              if (label) label.textContent = 'ADD';
            }, 900);
          })
          .catch(function (err) {
            console.warn('[watch-upsell]', err);
            btn.classList.remove('is-loading');
            btn.disabled = false;
            if (label) label.textContent = 'ADD';
          });
      });
    });
  }

  function init(root) {
    if (!root) return;
    if (!root.querySelectorAll('[data-watch-upsell-slide]').length) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    initDots(root);
    bindAdd(root);
  }

  function boot() {
    document.querySelectorAll('[data-watch-upsell]').forEach(init);
    enableCheckoutIfNeeded();
  }

  function refreshUpsellFromApi() {
    var holder = document.querySelector('#cart-drawer [data-watch-upsell-holder]');
    if (!holder) return;
    var prevSrc = {};
    holder.querySelectorAll('[data-watch-upsell-slide]').forEach(function (slide) {
      var id = slide.getAttribute('data-product-id');
      var img = slide.querySelector('img');
      if (!id || !img) return;
      var src = img.getAttribute('src') || img.currentSrc || '';
      if (src) prevSrc[id] = src;
    });
    fetch('/cart?section_id=api-cart-items', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var api = doc.querySelector('[data-api-watch-upsell]');
        if (!api) return;
        holder.innerHTML = api.innerHTML;
        holder.querySelectorAll('[data-watch-upsell-slide]').forEach(function (slide) {
          var id = slide.getAttribute('data-product-id');
          var img = slide.querySelector('img');
          if (!img) return;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.loading = 'eager';
          img.decoding = 'async';
          if (id && prevSrc[id]) {
            img.setAttribute('src', prevSrc[id]);
          }
        });
        boot();
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshUpsellFromApi, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('theme:cart-drawer:open', function () {
    setTimeout(boot, 40);
  });
  document.addEventListener('theme:product:added', function () {
    setTimeout(boot, 40);
    scheduleRefresh();
    enableCheckoutIfNeeded();
  });
  document.addEventListener('theme:cart:change', function () {
    setTimeout(boot, 40);
    enableCheckoutIfNeeded();
  });
  document.addEventListener('shopify:section:load', boot);
})();
